import { useEffect, useState } from 'react';

import FieldViewAsToggle from '@atom/components/common/fieldViewAsToggle/FieldViewAsToggle';
import { Modal } from '@atom/mui';
import { FieldViewType } from '@atom/types/dataType';
import { WorkOrderField, WorkOrderFieldUpdatePayload } from '@atom/types/work';

type WorkOrderFieldListUpdateModalProps = {
  open: boolean;
  field: WorkOrderField | null;
  onClose: () => void;
  handleUpdate: (payload: WorkOrderFieldUpdatePayload) => void;
  loadingUpdate?: boolean;
};

const WorkOrderFieldListUpdateModal = ({
  open,
  field,
  onClose,
  handleUpdate,
  loadingUpdate,
}: WorkOrderFieldListUpdateModalProps) => {
  const [viewAs, setViewAs] = useState<FieldViewType | null>(
    field?.viewAs ?? null,
  );

  useEffect(() => {
    if (open) {
      setViewAs(field?.viewAs ?? null);
    }
  }, [open, field]);

  const handleSubmit = () => {
    handleUpdate({
      fieldId: field.id,
      // An empty string clears a list view back to dropdown
      viewAs: viewAs ?? '',
    });
  };

  return (
    <Modal
      title="Edit Field"
      open={open}
      onCancel={onClose}
      onConfirm={handleSubmit}
      confirmButtonText="Save"
      loading={loadingUpdate}
      disabled={viewAs === (field?.viewAs ?? null)}
      CancelButtonProps={{ 'data-cy': 'workOrderFieldListUpdateModalCancel' }}
      ConfirmButtonProps={{ 'data-cy': 'workOrderFieldListUpdateModalSave' }}
      data-cy="workOrderFieldListUpdateModal"
    >
      <FieldViewAsToggle
        viewAs={viewAs}
        onChange={setViewAs}
        optionCount={field?.enumeration?.length}
        dataCy="workOrderFieldListUpdateModalViewAsToggle"
      />
    </Modal>
  );
};

export default WorkOrderFieldListUpdateModal;
